import { React, CenterWrapper, View, SEO, Page } from 'lib'
import { Theme, Settings, HTMLStylesDark } from 'app'
import Privacy from './_privacy.js'
import TermsOfUse from './_terms.js'
import LegalHeader from './_header.js'

function AppPolicies(props) {
  return (
    <Page whiteBackground>
      <View style={styles.wrapper}>
        <SEO doNotTrack title={'Becon App Terms & Privacy Policy'} description={`This page explains Becon App's Privacy Policy and Terms & Conditions.`}/>
        <CenterWrapper style={styles.wrapper} contentContainerStyle={styles.content}>
          <LegalHeader/>
          <TermsOfUse/>
          <Privacy/>
        </CenterWrapper>
      </View>
    </Page>
  )
}


const styles = {
  wrapper: {
    minHeight: '100vh',
    ...Theme.center,
    ...Theme.flex,
    flexDirection: 'column',
    maxWidth: '100vw',
    marginTop: Theme.spacing(6),
    marginBottom: Theme.spacing(2),
    [Theme.media.down('mid')]: {
      marginTop: Theme.spacing(4),
      marginBottom: Theme.spacing(1),
    },
  },
  content: {
    ...HTMLStylesDark.plainText,
    display: 'flex',
    width: 'auto',
    maxWidth: Theme.values.maxTextContentWidth,
    flexDirection: 'column',
  },
}

export default AppPolicies
